import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Dashboard from '../components/Dashboard';

const PrivateRoute = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" />;
  }

  return <Dashboard />;
};

export default PrivateRoute;
